// extracted by mini-css-extract-plugin
export default {"container":"doc_idAlj","withMaxWidth":"doc_wit_2jLoV"};